export default __webpack_public_path__ + "static/media/mcap.88bdb6ce.jpg";